module.exports = __webpack_public_path__ + "static/media/kevin89.f08e40eb.png";